import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import RelatedServices from '../RelatedServices'
import { cld } from '../../../utils/cld'

const ImgPer1 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758316309/IMG_0722_twbkop.jpg"
const ImgPer2 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758316308/IMG_0716_zaobeo.jpg"
const ImgPer3 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758316308/IMG_0715_tixygm.jpg"

const callBtnStyle = {
  display: "inline-block",
  padding: "15px 35px",
  backgroundColor: "#90510F",
  color: "#ffffffff",
  fontWeight: "600",
  fontSize: "1.2rem",
  borderRadius: "8px",
  textDecoration: "none",
  border: "1px solid #ddd",
  transition: "transform 0.3s",
}

const Main = () => {
  const { t } = useTranslation()

  const sidebarLinks = [
    { to: "/makeup",           label: t('servicesSidebar.makeup'),          active: false },
    { to: "/permanent-makeup", label: t('servicesSidebar.permanentMakeup'), active: true  },
    { to: "/vega",             label: t('servicesSidebar.vega'),            active: false },
    { to: "/baby-lips",        label: t('servicesSidebar.babyLips'),        active: false },
    { to: "/eyelashes",        label: t('servicesSidebar.eyelashes'),       active: false },
    { to: "/nails",            label: t('servicesSidebar.nails'),           active: false },
    { to: "/depilation",       label: t('servicesSidebar.depilation'),      active: false },
    { to: "/hairdresser",      label: t('servicesSidebar.hairdresser'),     active: false },
  ]

  const ContactBox = () => (
    <div className="service-detail-contact wow fadeup-animation" data-wow-delay="1.1s">
      <h3 className="h3-title">{t('servicesSidebar.contactTitle')}</h3>
      <a
        href="tel:0653585545"
        style={callBtnStyle}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {t('servicesSidebar.callNow')}
      </a>
    </div>
  )

  return (
    <>
      <Bredcrumb title={t('permanentMakeupService.breadcrumbTitle')} subtitle={t('permanentMakeupService.breadcrumbSubtitle')} />

      <div className="about-area5 about-p p-relative">
        <div className="container pt-120 pb-90">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-4 order-1">
              <aside className="sidebar services-sidebar">
                <div className="sidebar-widget categories">
                  <div className="widget-content">
                    <ul className="services-categories">
                      {sidebarLinks.map(({ to, label, active }) => (
                        <li key={to} className={active ? 'active' : ''}>
                          <Link to={to}>{label} <i className="fa fa-arrow-right"></i></Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="d-none d-lg-block">
                  <ContactBox />
                </div>
              </aside>
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12 order-2">
              <div className="service-detail">
                <div className="content-box">
                  <h2>{t('permanentMakeupService.h2')}</h2>
                  <p>{t('permanentMakeupService.p1')}</p>
                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgPer1, { w: 1100 })} alt="Permanent Makeup" width="1100" height="724" loading="lazy" decoding="async" /></figure>
                      </div>
                      <div className="text-column col-xl-6 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgPer2, { w: 1100 })} alt="Permanent Makeup" width="1100" height="731" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>
                  <h3>{t('permanentMakeupService.whyTitle')}</h3>
                  <ul>
                    <p>{t('permanentMakeupService.whyP1')}</p>
                    <p>{t('permanentMakeupService.whyP2')}</p>
                    <p>
                      <strong>{t('permanentMakeupService.whyP3Note')}</strong>{' '}
                      {t('permanentMakeupService.whyP3')}
                    </p>
                  </ul>
                  <h3>{t('permanentMakeupService.aftercareTitle')}</h3>
                  <ul>
                    {t('permanentMakeupService.aftercareItems', { returnObjects: true }).map((item, i) => (
                      <li key={i}>{i + 1}. {item}</li>
                    ))}
                  </ul>
                  <br />
                  <div className="two-column">
                    <div className="row">
                      <div className="image-column col-xl-12 col-lg-12 col-md-12">
                        <figure className="image"><img src={cld(ImgPer3, { w: 1100 })} alt="Permanent Makeup" width="1100" height="729" loading="lazy" decoding="async" /></figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RelatedServices items={[{ to: "/vega", labelKey: "servicesSidebar.vega" }, { to: "/baby-lips", labelKey: "servicesSidebar.babyLips" }]} />
          <div className="row d-lg-none">
            <div className="col-12">
              <ContactBox />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Main
